import React, { useState, useRef, useEffect } from "react";
import ChallengeModal from "./ChallengeModal";
import ball from "../../../images/BasketBall.svg";
import { useLocation } from "react-router-dom";

const SetMatchButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const location = useLocation();
  const [position, setPosition] = useState({ 
    x: (window.innerWidth<=990 ? window.innerWidth - 50 : window.innerWidth - 100), 
    y: window.innerHeight - 170 // Positioned above OpenAI button
  });
  const [isDragging, setIsDragging] = useState(false);
  const buttonRef = useRef(null);
  const startPosRef = useRef({ x: 0, y: 0 });

  const constrainPosition = (x, y) => {
    const buttonSize = 60;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const constrainedX = Math.max(
      0, 
      Math.min(x, windowWidth - buttonSize)
    );

    const constrainedY = Math.max(
      0, 
      Math.min(y, (windowWidth <= 990 ? windowHeight - buttonSize - 130 : windowHeight - buttonSize - 70))
    );

    return { x: constrainedX, y: constrainedY };
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    
    const clientX = e.clientX || (e.touches && e.touches[0].clientX);
    const clientY = e.clientY || (e.touches && e.touches[0].clientY);

    if (clientX !== undefined && clientY !== undefined) {
      setIsDragging(true);
      startPosRef.current = {
        x: clientX - position.x,
        y: clientY - position.y
      };
    }
  };

  const handleMouseMove = (e) => {
    e.preventDefault();

    if (isDragging) {
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);

      if (clientX !== undefined && clientY !== undefined) {
        const newX = clientX - startPosRef.current.x;
        const newY = clientY - startPosRef.current.y;
        
        const constrainedPos = constrainPosition(newX, newY);
        setPosition(constrainedPos);
      }
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchmove', handleMouseMove, { passive: false });
      window.addEventListener('touchend', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleMouseMove);
      window.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setShowDateTimeModal(false);
  };
  const handleShowDateTimeModal = () => {
    setShowDateTimeModal(!showDateTimeModal);
  };
  
  if(location.pathname === '/home' || (window.innerWidth<=990 && location.pathname === '/reels' ) || (window.innerWidth<=990 && location.pathname=== '/messages')){
    return <></>;
  }
  if(location.pathname=== '/messages'){
    return <></>;
  }

  return (
    <>
      <div 
        ref={buttonRef}
        className="chatbot-button" 
        style={{
          position: 'fixed',
          left: position.x,
          top: position.y,
          cursor: isDragging ? 'grabbing' : 'grab',
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleMouseDown}
        onClick={handleOpenModal}
      >
        <img
          src={ball}
          alt="matchBall"
          className="chatbot-icon2"
          draggable="false"
        />
      </div>

      <ChallengeModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        handleShowDateModal={handleShowDateTimeModal}
        showDateTimeModal={showDateTimeModal}
      />
    </>
  );
};

export default SetMatchButton;